import plusMapper from './mappers/plus';
import plusQuery from './queries/plusQuery';
import plusQuery2 from './queries/plusQuery2';
import plusQuery3 from './queries/plusQuery3';

export const selectQueryForPage = ({ contentKey }) => {
  switch (contentKey) {
    case 'plus':
      return { query: plusQuery };
    case 'plus2':
      return { query: plusQuery2 };
    case 'plus3':
      return { query: plusQuery3 };
    default:
      throw new Error(`Could not find a graphql query for ${contentKey}`);
  }
};

export const selectMapperForPage = ({ contentKey }) => {
  switch (contentKey) {
    case 'plus':
      return plusMapper;
    default:
      throw new Error(`Could not find mapper for contentKey: ${contentKey}`);
  }
};
